<div class="breadcrumb-area">
	<h1>Reporte de Contabilidad</h1>
</div>
<div class="card mb-3" id="bookReports"  [appCheckPermission]="[5000, 5006, 2130, 2131, 2137, 2138]"
[permissionType]="permissionType.ALL">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="selectedReport = selectedReport==1?0:1">
		<h3>Reporte de Libros</h3>
		<h3><i [ngClass]="selectedReport==1?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==1">
		<div class="row">
			<div class="col-sm">
				<div class="form-group">
					<label for="startDate1" class="form-label">Fecha Inicial:</label>
					<input type="date" [(ngModel)]="startDate" id="startDate1" name="startDate1" class="form-control">
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="endDate1" class="form-label">Fecha Final:</label>
					<input type="date" [(ngModel)]="endDate" id="endDate1" name="endDate1" class="form-control">
				</div>
			</div>
		</div>
		<div class="row">
			<div class="card col-sm" *ngFor="let report of bookReports" [appCheckPermission]="report.permissions"
			[permissionType]="permissionType.ALL">
				<p [hidden]="report.byMonth==null" style="margin: 0;font-size: 0.8em; text-align: right;"><span
						class="byMonth" (click)="report.byMonth = !report.byMonth"
						[class.active-month]="report.byMonth"><i
							[ngClass]="report.byMonth?'fa fa-circle-check':'fa-regular fa-circle'" class=""></i>Reporte
						Mensual</span></p>
				<p [hidden]="report.byMonth!=null" style="margin: 0;font-size: 0.8em; text-align: right; color: white;">
					.</p>
				<h4>{{report.name}}</h4>
				<div style="justify-content: space-evenly;" class="download-buttons">
					<button [disabled]="report.excel" (click)="getBook('excel',report)" class="btn btn-success"
						data-bs-toggle="tooltip" title="Descargar Excel"><i *ngIf="!report.excel"
							class="fa fa-file-excel"></i>
						<span *ngIf="report.excel" class="spinner-border spinner-border-sm"
							aria-hidden="true"></span></button>
					<button [disabled]="report.pdf" (click)="getBook('pdf', report)" class="btn btn-primary"
						data-bs-toggle="tooltip" title="Descargar PDF"><i *ngIf="!report.pdf"
							class="fa fa-file-pdf"></i>
						<span *ngIf="report.pdf" class="spinner-border spinner-border-sm"
							aria-hidden="true"></span></button>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="card mb-3" id="balanceReports"  [appCheckPermission]="[5000, 5006, 2133, 2134]"
[permissionType]="permissionType.ALL">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="selectedReport = selectedReport==2?0:2">
		<h3>Reporte de Balances</h3>
		<h3><i [ngClass]="selectedReport==2?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==2">
		<div class="row">
			<div class="col-sm">
				<div class="form-group">
					<label for="endDate2" class="form-label">Fecha:</label>
					<input type="date" [(ngModel)]="endDate" id="endDate2" name="endDate2" class="form-control">
				</div>
			</div>
		</div>
		<div class="row">
			<div class="card col-sm" *ngFor="let report of balanceReports; let i = index" [appCheckPermission]="report.permissions"
			[permissionType]="permissionType.ALL">
				<h4>{{report.name}}</h4>
				<div style="justify-content: space-evenly;" class="download-buttons">
					<div class="input-group input-group-sm" style="width: 50%;" *ngIf="report.level!=null">
						<label for="level" class="input-group-text">Nivel</label>
						<select name="level" [(ngModel)]="report.level" class="form-select" id="level">
							<option value="1">1</option>
							<option value="2">2</option>
							<option value="3">3</option>
							<option value="4">4</option>
						</select>
					</div>
					<button [disabled]="report.excel" (click)="getBalance('excel',report)" class="btn btn-success"
						data-bs-toggle="tooltip" title="Descargar Excel"><i *ngIf="!report.excel"
							class="fa fa-file-excel"></i>
						<span *ngIf="report.excel" class="spinner-border spinner-border-sm"
							aria-hidden="true"></span></button>
					<button [disabled]="report.pdf" (click)="getBalance('pdf', report)" class="btn btn-primary"
						data-bs-toggle="tooltip" title="Descargar PDF"><i *ngIf="!report.pdf"
							class="fa fa-file-pdf"></i>
						<span *ngIf="report.pdf" class="spinner-border spinner-border-sm"
							aria-hidden="true"></span></button>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="card mb-3" id="resultReport" [appCheckPermission]="otherBooks[0].permissions"
[permissionType]="permissionType.ALL">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="selectedReport = selectedReport==3?0:3">
		<h3>Estado de Resultados</h3>
		<h3><i [ngClass]="selectedReport==3?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==3">
		<div class="row">
			<div class="col-sm-5">
				<div class="form-group">
					<label for="startDate3" class="form-label">Fecha Inicial:</label>
					<input type="date" [(ngModel)]="startDate" id="startDate3" name="startDate3" class="form-control">
				</div>
			</div>
			<div class="col-sm-5">
				<div class="form-group">
					<label for="endDate3" class="form-label">Fecha Final:</label>
					<input type="date" [(ngModel)]="endDate" id="endDate3" name="endDate3" class="form-control">
				</div>
			</div>
			<div class="col-sm-2 download-buttons">
				<button [disabled]="otherBooks[0].excel" (click)="getBook('excel',otherBooks[0])"
					class="btn btn-success" data-bs-toggle="tooltip" title="Descargar Excel"><i
						*ngIf="!otherBooks[0].excel" class="fa fa-file-excel"></i>
					<span *ngIf="otherBooks[0].excel" class="spinner-border spinner-border-sm"
						aria-hidden="true"></span></button>
				<button [disabled]="otherBooks[0].pdf" (click)="getBook('pdf', otherBooks[0])" class="btn btn-primary"
					data-bs-toggle="tooltip" title="Descargar PDF"><i *ngIf="!otherBooks[0].pdf"
						class="fa fa-file-pdf"></i>
					<span *ngIf="otherBooks[0].pdf" class="spinner-border spinner-border-sm"
						aria-hidden="true"></span></button>
			</div>
		</div>
	</div>
</div>
<div class="card mb-3" id="cashFlowReport"  [appCheckPermission]="otherBooks[1].permissions"
[permissionType]="permissionType.ALL">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="selectedReport = selectedReport==4?0:4">
		<h3>{{otherBooks[1].name}}</h3>
		<h3><i [ngClass]="selectedReport==4?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==4">
		<div class="row">
			<div class="col-sm-10">
				<div class="form-group">
					<label for="endDate4" class="form-label">Fecha:</label>
					<input type="date" [(ngModel)]="endDate" id="endDate4" name="endDate4" class="form-control">
				</div>
			</div>
			<div class="col-sm-2 download-buttons">
				<button [disabled]="otherBooks[1].excel" (click)="getBook('excel',otherBooks[1])"
					class="btn btn-success" data-bs-toggle="tooltip" title="Descargar Excel"><i
						*ngIf="!otherBooks[1].excel" class="fa fa-file-excel"></i>
					<span *ngIf="otherBooks[1].excel" class="spinner-border spinner-border-sm"
						aria-hidden="true"></span></button>
				<button [disabled]="otherBooks[1].pdf" (click)="getBook('pdf', otherBooks[1])" class="btn btn-primary"
					data-bs-toggle="tooltip" title="Descargar PDF"><i *ngIf="!otherBooks[1].pdf"
						class="fa fa-file-pdf"></i>
					<span *ngIf="otherBooks[1].pdf" class="spinner-border spinner-border-sm"
						aria-hidden="true"></span></button>
			</div>
		</div>
	</div>
</div>
<div class="card mb-3" id="moneyReports"  [appCheckPermission]="otherBooks[2].permissions"
[permissionType]="permissionType.ALL">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="selectedReport = selectedReport==5?0:5">
		<h3>Reporte de Estados Financieros</h3>
		<h3><i [ngClass]="selectedReport==5?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==5">
		<div class="row">
			<div class="col-sm">
				<div class="form-group">
					<label for="endDate5" class="form-label">Fecha:</label>
					<input type="date" [(ngModel)]="endDate" id="endDate5" name="endDate5" class="form-control">
				</div>
			</div>
			<div class="col-sm download-buttons">
				<span>{{otherBooks[2].name}}</span>
				<button [disabled]="otherBooks[2].pdf" (click)="getBook('pdf', otherBooks[2])"
					class="btn btn-primary" data-bs-toggle="tooltip" title="Descargar PDF"><i *ngIf="!otherBooks[2].pdf"
						class="fa fa-file-pdf"></i>
					<span *ngIf="otherBooks[2].pdf" class="spinner-border spinner-border-sm"
						aria-hidden="true"></span></button>
			</div>
			<div class="col-sm download-buttons">
				<span>{{otherBooks[3].name}}</span>
				<button [disabled]="otherBooks[3].pdf" (click)="getBook('pdf', otherBooks[3])"
					class="btn btn-primary" data-bs-toggle="tooltip" title="Descargar PDF"><i *ngIf="!otherBooks[3].pdf"
						class="fa fa-file-pdf"></i>
					<span *ngIf="otherBooks[3].pdf" class="spinner-border spinner-border-sm"
						aria-hidden="true"></span></button>
			</div>
		</div>
	</div>
</div>